import React from "react";
import MainAppGenericModal from "../../../../atoms/Modals/GenericModal";
import i18n from "i18n";

import styles from "./MainApp.organisms.Product.Modals.ProductModalWrapper.module.scss";
export class ProductModalWrapper extends React.Component {
  render() {
    const {
      innerContent,
      open,
      buttonLegend,
      handleGoBack,
      handleDownloadTemplate,
      handleClose,
      handleClick,
      handleButtonClick,
      footer,
    } = this.props;

    const content = (
      <div className={styles["product-modal-wrapper"]}>
        <i
          className={`icon-iconos_close2 ${styles["product-modal-wrapper-close"]}`}
          onClick={handleGoBack}
          data-automation-id="go-back"
        ></i>
        <i className={`icon-iconos_alerta ${styles["product-modal-wrapper-icon"]}`}></i>

        <div className={styles["product-modal-wrapper-content"]}>{innerContent}</div>
        <div
          className={styles["product-modal-wrapper-button"]}
          onClick={handleButtonClick && handleButtonClick}
        >
          <label className={styles["product-modal-wrapper-button-label"]}>
            {buttonLegend}
            {!handleButtonClick && (
              <input
                type="file"
                name="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleClick}
              ></input>
            )}
          </label>
        </div>
        {footer && footer}
        {!footer && (
          <div className={styles["product-modal-wrapper-footer"]}>
            {i18n.t("questions.about.file")}{" "}
            <span
              className={styles["product-modal-wrapper-span"]}
              onClick={handleDownloadTemplate}
              data-automation-id="download-template"
            >
              {i18n.t("download.here")}{" "}
            </span>
            {i18n.t("example.to.guide")}
          </div>
        )}
      </div>
    );
    return (
      <div className={styles["product-modal-container"]}>
        <MainAppGenericModal
          open={open}
          content={content}
          handleClose={handleClose}
        />
      </div>
    );
  }
}

ProductModalWrapper.propTypes = {};

export default ProductModalWrapper;
